import firebase from 'firebase'
import 'firebase/firestore'
// a1lci65L9fsS5RD6iWl6

const config = {
  apiKey: "AIzaSyCGDU9spMcwoZ-CwN3P14aNutdq5I5OBlg",
  authDomain: "xmooc-iet.firebaseapp.com",
  projectId: "xmooc-iet",
  storageBucket: "xmooc-iet.appspot.com",
  messagingSenderId: "875878107283",
  appId: "1:875878107283:web:923c75802b4b5564b3e566",
  measurementId: "G-D5HEBTB251"
}

firebase.initializeApp(config)
// firebase utils
const firestore = firebase.firestore
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const yyschool = "/schools/YJHjHWUGDok8teDhDIKX"
var googleProvider = new firebase.auth.GoogleAuthProvider()
googleProvider.addScope('email')
const usersCollection = db.collection('users')
const storage = firebase.storage
const storageRef = firebase.storage().ref()
export {
    db,
    auth,
    currentUser,
    googleProvider,
    usersCollection,
    storage,
    storageRef,
    firestore,
    yyschool
}
